import { render, staticRenderFns } from "./gzzoc-disease.vue?vue&type=template&id=58b1e276&scoped=true&lang=pug&"
import script from "./gzzoc-disease.vue?vue&type=script&lang=js&"
export * from "./gzzoc-disease.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-disease.vue?vue&type=style&index=0&id=58b1e276&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1e276",
  null
  
)

export default component.exports